// import configAdmin from "@/configs/admin.js";
// import store from "@/store";
let _created = {
  init() {
    // const localAppString = localStorage.getItem(configAdmin.localstorage_key);
    // if (localAppString) {
    //   const localApp = JSON.parse(localAppString);
    //   if ("userStore" in localApp) {
    //     store.commit("userStore/SAVE_USER_SESSION", localApp.userStore);
    //   }
    // }
  },
};

export default _created;
